// Arabic translations
const ar = {
  // Placeholder structure to prevent errors
  navigation: {
    tracking: "تتبع",
    search: "بحث",
    login: "حسابي",
    language: "اللغة"
  },
  
  menu: {
    solutions: "حلول",
    industries: "صناعات",
    ebusiness: "الأعمال الإلكترونية",
    sustainability: "الاستدامة",
    aboutUs: "من نحن",
    schedules: "جداول"
  },
  
  hero: {
    leaderIn: "الرائد في",
    shippingLogistics: "الشحن والخدمات اللوجستية",
    trackingTab: "تتبع",
    schedulesTab: "جداول",
    contactsTab: "جهات الاتصال",
    containerBol: "حاوية / رقم بوليصة الشحن",
    bookingNumber: "رقم الحجز",
    searchPlaceholder: "ابحث عن خدماتنا وحلولنا...",
    searchButton: "بحث"
  },
  
  // Default fallback for other sections
  example: {},
  services: {},
  stats: {
    title: "انتشار عالمي، خبرة محلية",
    description: "مع شبكة عالمية قوية ومعرفة محلية عميقة، نقوم بربط الأعمال عبر القارات.",
    years: "سنوات من الخبرة",
    countries: "البلدان التي نخدمها",
    clients: "عملاء نشطون",
    shipments: "شحنات سنوية"
  },
  industries: {},
  footer: {}
};

export default ar; 